@let selectedEmployees = selectedEmployeesSg();
@let employees = employeesSg();
@let isSubmitting =
  collectionSg().plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-centered-overlay type="wide">
  <div class="atn-space-responsible-persons-modal">
    <atn-ds-widget title="Add Responsible Person(s)">
      <div actions>
        <i
          class="atn-icon atn-close atn-red"
          (click)="cancelClickHandler()"
        ></i>
      </div>

      <div class="atn-space-responsible-persons-modal__content">
        <atn-space-modal-employee-selector
          [employees]="employees"
          [selectedEmployees]="selectedEmployees"
          (employeeToggled)="employeeToggledHandler($event.id, $event.selected)"
          (employeeRemoved)="removeSelectedEmployee($event)"
        />

        @if (employeeItemsSg().length > 0) {
          <atn-ds-select-single
            label="New Primary Responsible Person"
            [items]="employeeItemsSg()"
            [value]="primaryEmployeeIdSg()"
            (valueChange)="primaryEmployeeChangedHandler($event)"
          />
        }
      </div>

      <div
        class="atn-space-responsible-persons-modal__footer"
        footer
      >
        <atn-ds-checkbox
          label="Add also to occupants when selected"
          (selectedChange)="addAsOccupantSelectionChangeHandler($event)"
        />
        <div class="atn-space-responsible-persons-modal__footer-buttons">
          <atn-ds-button
            type="transparent"
            (click)="cancelClickHandler()"
            >Cancel</atn-ds-button
          >
          <atn-ds-button
            (click)="saveClickHandler()"
            [disabled]="!selectedEmployees.length"
            [loading]="isSubmitting"
            >Save</atn-ds-button
          >
        </div>
      </div>
    </atn-ds-widget>
  </div>
</atn-ds-centered-overlay>
